import {AbstractControl} from '@angular/forms';

export function createStaticValidator<E>(test: (control: AbstractControl) => boolean, error: E) {
  return (control: AbstractControl) => {
    return !test(control) ? error : null;
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/common.ts